<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <strong>{{$t('NEWKEYPADCODE')}}</strong>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-sm-12">
                                <b-form-fieldset v-bind:label="$t('KEYPADCODE')">
                                    <inputvalidation :formerror="formError" name="code">
                                        <b-form-input type="text" v-model="formData.code" v-bind:placeholder="$t('KEYPADCODE')"></b-form-input>
                                    </inputvalidation>
                                </b-form-fieldset>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <b-form-fieldset v-bind:label="$t('DESCRIPTION')">
                                    <inputvalidation :formerror="formError" name="description">
                                        <b-form-input type="text" v-model="formData.description" v-bind:placeholder="$t('DESCRIPTION')"></b-form-input>
                                    </inputvalidation>
                                </b-form-fieldset>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <b-form-fieldset v-bind:label="$t('INDEX')">
                                    <inputvalidation :formerror="formError" name="index">
                                        <b-form-input type="text" v-model="formData.index" v-bind:placeholder="$t('INDEX')"></b-form-input>
                                    </inputvalidation>
                                </b-form-fieldset>
                            </div>
                        </div>
                        <div slot="footer">
                            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
                            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
                        </div>
                    </div>
                </b-card>
            </div>
            <!--/.col-->
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> {{$t('KEYPADCODES')}}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-3">
                                <b-form-fieldset v-bind:label="$t('SEARCH')">
                                    <b-form-input v-model="pagination.query"></b-form-input>
                                </b-form-fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
                        <p class="center">{{$t('NODATAFOUND')}}</p>
                    </div>
                    <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
                        <table class="table table-responsive-sm table-striped">
                            <thead>
                                <tr>
                                    <th>{{$t('ID')}}</th>
                                    <th>{{$t('KEYPADCODE')}}</th>
                                    <th>{{$t('DESCRIPTION')}}</th>
                                    <th>{{$t('INDEX')}}</th>
                                    <th>{{$t('ACTIONS')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in data.root" :key="item.keypadCodeId">
                                    <td>{{item.keypadCodeId}}</td>
                                    <td>
                                        {{item.code}}
                                    </td>
                                    <td>
                                        {{item.description}}
                                    </td>
                                    <td>
                                        {{item.index}}
                                    </td>
                                    <td>
                                        <b-button type="reset" size="sm" variant="primary" v-on:click.prevent="syncCode(item)"><icon name="save"></icon> {{$t('SYNCKEYPADCODE')}}</b-button>
                                        <b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.keypadCodeId)">
                                            <icon name="ban"></icon> {{$t('DELETE')}}
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <nav>
                            <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapGetters
}
from 'vuex'
import Api from '@/api/KeypadCodes'

export default
{
    name: 'KeypadCodes',
    data: function()
    {
        var me = this;
        return {
            data:
            {},
            formError:
            {},
            modulesData:
            {},
            formData:
            {
                "id": "",
                "moduleId": "",
                "code": ""
            },
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                searchTimeout: false
            }
        }
    },
    created: function()
    {
        var me = this;
        me.formData.moduleId = me.$route.params.moduleId;
        me.getData();
    },
    methods:
    {
        syncCode(item)
        {
            var me = this;
            item.id = item.keypadCodeId;
            Api.syncCode(item, function(val)
            {
                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.formError = {};
                    me.getData();
                }
            })
        },
        saveRow: function(item)
        {
            var me = this;

            Api.save(item, function(val)
            {
                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.formError = {};
                    me.getData();
                }
            })
        },
        getData: function()
        {
            var me = this;
            Api.selectRow(me.getParams, function(data)
            {
                if (data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }
                me.data = data;
            });
        },
        deleteRow: function(id)
        {
            var me = this;
            me.$store.commit('setModalAlert',
            {
                text: me.$i18n.t('AREYOUSHURE'),
                btnAction: function()
                {
                    Api.deleteRow(
                    {
                        id: id
                    }, function(data)
                    {
                        me.$notify.notice(data);
                        me.getData();
                    })
                }
            })
        }
    },
    watch:
    {
        'pagination.currentPage': function(val)
        {
            var me = this;
            me.getData();
        },
        'pagination.query': function(val)
        {
            var me = this;

            if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

            me.pagination.searchTimeout = setTimeout(function()
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'socket'
        ]),
        getParams: function()
        {
            var me = this;
            var data = Object.assign(
            {}, me.pagination,
            {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        }
    }
}
</script>
